import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SouburWordmark } from "./SoubourMark";

/**
 * Top navigation for the marketing landing.
 * `onBookDemo` opens the demo modal in the page (passed from Landing.jsx).
 */
export const SiteNav = ({ onBookDemo }) => {
    const [open, setOpen] = useState(false);

    const handleBook = (e) => {
        e?.preventDefault?.();
        setOpen(false);
        if (onBookDemo) onBookDemo();
    };

    return (
        <header
            data-testid="site-nav"
            className="sticky top-0 z-40 backdrop-blur-xl bg-[rgba(5,5,5,0.7)] border-b hairline"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
                <Link to="/" data-testid="nav-home" aria-label="Floodlight home">
                    <SouburWordmark animated />
                </Link>

                <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-400">
                    <a href="#how-it-works" className="link-rule hover:text-white transition-colors" data-testid="nav-how-it-works">How it works</a>
                    <a href="#in-action" className="link-rule hover:text-white transition-colors" data-testid="nav-in-action">See it in action</a>
                    <a href="#pricing" className="link-rule hover:text-white transition-colors" data-testid="nav-pricing">Pricing</a>
                    <a href="#faq" className="link-rule hover:text-white transition-colors" data-testid="nav-faq">FAQ</a>
                </nav>

                <div className="hidden md:flex items-center gap-3">
                    <Link
                        to="/login"
                        className="text-sm text-zinc-300 hover:text-white px-4 py-2"
                        data-testid="nav-signin"
                    >
                        Sign in
                    </Link>
                    <button
                        onClick={handleBook}
                        className="inline-flex items-center gap-2 bg-[var(--sb-amber)] text-black font-semibold tracking-tight text-sm px-5 py-2.5 hover:brightness-110 transition-all"
                        data-testid="nav-book-demo"
                    >
                        Book a demo
                    </button>
                </div>

                <button
                    className="md:hidden text-white p-2"
                    onClick={() => setOpen((s) => !s)}
                    data-testid="nav-mobile-toggle"
                    aria-label="Toggle navigation"
                >
                    {open ? <X size={20} /> : <Menu size={20} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t hairline" data-testid="nav-mobile-panel">
                    <div className="px-6 py-6 flex flex-col gap-4 text-sm">
                        <a href="#how-it-works" className="text-zinc-300" onClick={() => setOpen(false)}>How it works</a>
                        <a href="#in-action" className="text-zinc-300" onClick={() => setOpen(false)}>See it in action</a>
                        <a href="#pricing" className="text-zinc-300" onClick={() => setOpen(false)}>Pricing</a>
                        <a href="#faq" className="text-zinc-300" onClick={() => setOpen(false)}>FAQ</a>
                        <Link to="/login" className="text-zinc-300 border-t hairline pt-4" onClick={() => setOpen(false)}>Sign in</Link>
                        <button
                            onClick={handleBook}
                            className="bg-[var(--sb-amber)] text-black font-semibold px-5 py-3 text-center"
                        >
                            Book a demo
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
};

export default SiteNav;
